export default __webpack_public_path__ + "ed686902950a0b3331a240e51a1ab92b.svg";